import { motion } from 'framer-motion'
import { styled, createGlobalStyle } from 'styled-components'
import { COLORS } from 'consts/colors'
import { SLIDE_UP_Z_INDEX } from 'consts/zIndex'

export const Container = styled.div<{ $zIndex?: number }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${({ $zIndex }) => $zIndex ?? SLIDE_UP_Z_INDEX};
`

export const Content = styled(motion.div)<{
  $bottomMargin: number
  $minHeight?: string
  $maxHeight?: string
}>`
  position: absolute;
  left: 0;
  right: 0;
  bottom: ${({ $bottomMargin }) => `${$bottomMargin}px`};
  border-radius: 12px 12px 0 0;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.32);
  background-color: ${COLORS.white};
  padding-top: 20px;
  max-height: ${({ $maxHeight }) => $maxHeight ?? 'calc(100% - 148px)'};
  min-height: ${({ $minHeight }) => $minHeight ?? '0'};
  display: flex;
  flex-direction: column;
`

export const CloseLine = styled.div`
  margin: 0 auto;
  width: 60px;
  height: 4px;
  background-color: ${COLORS.secondaryLight};
  cursor: pointer;
  border-radius: 4px;
`

export const BackdropOverlay = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.4);
`

export const GlobalScrollBlock = createGlobalStyle`
  body {
    overflow: hidden !important;
  }
`
